import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "..";
import { Button, CustomLink, Input, Keyboard, Layout, Result, Row } from "../components";
import logo from "../assets/logo.svg";
import config from "../config";
import $api from "../http";
import { Response } from "../types";
import { AxiosResponse } from "axios";
import { observer } from "mobx-react";

const ReportPage: FC<{ title: string }> = observer(({ title }) => {
  const { store } = useContext(Context);
  const navigate = useNavigate();
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
  }, [navigate, store.isAuth]);

  const [masters, setMasters] = useState<any[]>();
  const [stat, setStat] = useState<any[]>([]);

  useEffect(() => {
    $api.get(`${config.API}/master/report`).then(({ data }) => {
      setMasters(data.data);
      data.data.forEach((e: any) => {
        if (e.stat.length !== 0) {
          setStat((prev) => [
            ...prev,
            {
              count: e.stat.length,
              name: e.name,
              money: e.summaryMoney * 0.5,
              sixCount: e.stat.filter((i: any) => i.isSix).length,
              sixMoney: e.sixsSum,
            },
          ]);
        }
        setAllJoins((prev) => (prev += e.stat.length));
        setSumSixs((prev) => (prev += e.sixsSum));
        e.stat.forEach((p: any) => {
          setAllMoney((prev) => (prev += p.price));
          setAllSixs((prev) => (prev += p.isSix ? 1 : 0));
          setResultMoney((prev) => (prev += p.price));
        });
      });
    });
  }, []);

  const [allJoins, setAllJoins] = useState<number>(0);
  const [allSixs, setAllSixs] = useState<number>(0);
  const [sumSixs, setSumSixs] = useState<number>(0);
  const [allMoney, setAllMoney] = useState<number>(0);
  const [resultMoney, setResultMoney] = useState<number>(0);

  const [result, setResult] = useState<Response>({ status: "error", message: "" });

  const [terminal, setTerminal] = useState<string>("");
  const [salary, setSalary] = useState<string>("");

  useEffect(() => {
    setResultMoney(allMoney * 0.5 - Number(terminal) - sumSixs + Number(salary));
  }, [terminal, allMoney, sumSixs, salary]);

  useEffect(() => {
    $api.get(`${config.API}/master/reports?date=${new Date().toLocaleDateString("ru")}`).then(({ data }) => {
      const { terminal, card } = data.data[data.data.length - 1];
      if (!terminal || !card) return;
      setTerminal(terminal);
      setSalary(card);
    });
  }, []);

  const sendData = () => {
    $api
      .post(`${config.API}/master/report`, {
        terminal: Number(terminal),
        allJoins: Number(allJoins),
        allSixs: Number(allSixs),
        allSalary: resultMoney,
        stat,
        card: Number(salary),
      })
      .then(({ data }: AxiosResponse<Response>) => {
        setResult(data);
      });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={128} height={128} />
      <CustomLink to="/default">Вернуться</CustomLink>
      <Row style={{ gap: 30 }}>
        <div>
          <p>Терминал</p>
          <Input
            type={"number"}
            placeholder="Терминал"
            style={{ marginBottom: 20 }}
            value={terminal}
            onChange={({ target }) => Number(target.value) && setTerminal(target.value)}
          />
          <Keyboard
            type="phone"
            onClick={(e: string) => {
              if (e === "<-") return setTerminal((prev) => prev.substring(0, prev.length - 1));
              (Number(e) || e === "0") && setTerminal((prev) => prev + e);
            }}
          />
        </div>
        <div>
          <div style={{ marginBottom: 60 }}>
            <p>
              <b>Всего посещений: {allJoins}</b>
            </p>
            {masters &&
              masters.map((e: any) => (
                <p key={e.name}>
                  {e.name}: {e.stat.length}
                </p>
              ))}
          </div>
          <div>
            <p>
              <b>
                Из них шестых: {allSixs} ({sumSixs}р)
              </b>
            </p>
            {masters &&
              masters.map((e: any) => (
                <p key={e.name}>
                  {e.name}: {e.stat.filter((i: any) => i.isSix).length} ({e.sixsSum}р)
                </p>
              ))}
          </div>
        </div>
        <div>
          <div style={{ marginBottom: 60 }}>
            <p>
              <b>Зарплата: {allMoney * 0.5}</b>
            </p>
            {masters &&
              masters.map((e: any) => (
                <p key={e.name}>
                  {e.name}: {e.summaryMoney * 0.5}
                </p>
              ))}
          </div>
          <div>
            <p>
              <b>Итого сдаем: {resultMoney}</b>
            </p>
          </div>
          <Button onClick={sendData}>Сохранить</Button>
          <Result {...result} />
        </div>
        <div>
          <p>ЗП на карту</p>
          <Input
            type={"number"}
            placeholder="ЗП на карту"
            style={{ marginBottom: 20 }}
            value={salary}
            onChange={({ target }) => Number(target.value) && setSalary(target.value)}
          />
          <Keyboard
            type="phone"
            onClick={(e: string) => {
              if (e === "<-") return setSalary((prev) => prev.substring(0, prev.length - 1));
              (Number(e) || e === "0") && setSalary((prev) => prev + e);
            }}
          />
        </div>
      </Row>
    </Layout>
  );
});

export default ReportPage;
